import { BaseRepository } from './BaseRepository'

/**
 * SignaturesRepository — re-implementacion limpia (SQL) de occurrence.saveSignature de
 * v1 src/offline/modules/occurrences.js (REFERENCIA — NO importado).
 *
 * Tabla `signatures`, entity `occurrence`, pk `client_uuid`. Las firmas son EVENTS:
 * NO se coalescen (pueden guardarse varias firmas distintas para la misma occurrence
 * antes de reconectar y cada una debe persistir). Usa el camino publico saveOptimistic
 * (executeSet, no-coalesce). body NORMALIZADO: { occurrence_id, payload } — payload =
 * refs unicamente, NUNCA binario (la firma vive como image_ref/local_path).
 */
export class SignaturesRepository extends BaseRepository {
  constructor () {
    super('signatures', 'occurrence', 'client_uuid')
  }

  /**
   * Anade una firma (EVENT, no coalesce).
   * @param {object} sigRow  fila de la firma (incluye client_uuid, occurrence_id).
   * @param {object} [opts] { payload } refs-only (no binario).
   * @returns {Promise<string>} client_uuid.
   */
  async addSignature (sigRow = {}, { payload } = {}) {
    const uuid = sigRow.client_uuid
    return this.saveOptimistic({
      clientUuid: uuid,
      dataRow: { ...sigRow },
      op: 'occurrence.saveSignature',
      coalesce: false,
      body: { occurrence_id: sigRow.occurrence_id, payload }
    })
  }
}

export const signaturesRepository = new SignaturesRepository()
